import flow_id from "./flowId";
var getMId = function getMId() {
  if (typeof localStorage !== "undefined") {
    return localStorage.getItem("mId") || "";
  }
  return "";
};
/**
 * @description 是否浏览器环境
 * @returns {boolean}
 */
export function isBrowser() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * @description 获取cookie
 * @param {string} cookieName
 * @returns {string}
 */
export function getCookie(cookieName) {
  if (!isBrowser() && typeof document !== "undefined") {
    var cookieString = RegExp("" + cookieName + "[^;]+").exec(document.cookie);
    return decodeURIComponent(cookieString ? cookieString.toString().replace(/^[^=]+./, "") : "");
  }
  return "";
}
// ga4通用字段
export var ga4PublicField = {
  device_id: getCookie("uuid"),
  sub_platform: "PC",
  user_id: getMId(),
  flow_id: flow_id()
};
// ga4 通用统计方法
export var ga4Collect = function ga4Collect(eventName, targetData) {
  var _a;
  try {
    // 只有 isHoneypot 不等于1的时候才会进行 ga4 统计, 后端配置
    if (String(window === null || window === void 0 ? void 0 : window.isHoneypot) !== "1") {
      (_a = window === null || window === void 0 ? void 0 : window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", eventName, Object.assign(Object.assign({}, ga4PublicField), targetData));
    }
  } catch (e) {
    console.log({
      error: e,
      source: "lib-ga4-ga4Collect"
    });
  }
};
export var g4 = function g4(eventName, targetData) {
  var _a;
  try {
    (_a = window === null || window === void 0 ? void 0 : window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", eventName, Object.assign(Object.assign({}, ga4PublicField), targetData));
  } catch (e) {}
};
export var determinePagePlatform = function determinePagePlatform() {
  try {
    var pageRoute = window === null || window === void 0 ? void 0 : window.page_route;
    if (pageRoute === "t8891:index_index") {
      return "t8891-index";
    } else if ((pageRoute === null || pageRoute === void 0 ? void 0 : pageRoute.indexOf("newCar")) !== -1) {
      return "newcar";
    } else {
      return "auto";
    }
  } catch (e) {}
};